// Helpers
import noise3d from './shaders/helpers/noise-3d.glsl';
import noise2d from './shaders/helpers/noise-2d.glsl';
// Blob
import blobFragment from './shaders/blob/fragment.glsl';
import blobVertex from './shaders/blob/vertex.glsl';
// Vertex
import hypermeshFragment from './shaders/hypermesh/fragment.glsl';
import hypermeshVertex from './shaders/hypermesh/vertex.glsl';

const SHADERS = {
    blobFragment,
    blobVertex,
    hypermeshFragment,
    hypermeshVertex
}

// Shader chunks
const CHUNKS = {
    noise3d,
    noise2d
}

// Resolve Includes
const includePattern = /^[ \t]*#include +<([\w\d./]+)>/gm;
function resolveIncludes( string ) {
	return string.replace( includePattern, (match, include) => {
        const result = CHUNKS[include];

        if(result === undefined) {
            throw new Error(`Can not resolve #include <${include}>`)
        }

        return resolveIncludes( result );
    } );
}

export default function(key) {
    return resolveIncludes(SHADERS[key])
}